import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CardGiftcardOutlinedIcon from '@material-ui/icons/CardGiftcardOutlined';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import { IconButton } from '@material-ui/core';
import { personalinfo } from '../functions/auth';
import logo from "../img/logo2.png"
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(theme => ({

    container: {
        width: "100%",
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch',
        justifyContent: "center",
        "@media(max-width:770px)": {
            flexDirection: 'column',
            alignItems: 'center',
        }
    },

    box: {

        margin: "20px",
        "@media(max-width:770px)": {
            margin: "10px"
        }

    },

    charactor: {

        width: "450px",
        //  height: "450px",
        backgroundColor: "white",
        textAlign: "center",
        borderRadius: "10px",
        boxShadow: "1px 1px 1px 1px rgba(0,0,0,0.1)",

        "& div": {
            fontSize: "25px",
            padding: "20px",
            fontWeight: "bold",
            textAlign: "left",
        },
        "& img": {
            width: "400px",
            height: "250px",
            margin: "20px",
            "@media(max-width:770px)": {
                width: "80%",
                margin: "0px"
            }

        },

        "@media(max-width:770px)": {
            width: "100%",
        }

    },

    basic: {
        width: "450px",
        height: "255px",

        boxShadow: "1px 1px 1px 1px rgba(0,0,0,0.1)",
        borderRadius: "10px",
        backgroundColor: "white",
        margin: "10px 0px",
        "& div": {
            padding: "20px",
            fontSize: "25px",
            fontWeight: "bold",
        },

        "& li": {
            fontSize: "20px",
            padding: "10px",
        },

        "@media(max-width:770px)": {
            width: "100%",
        }

    },

    information: {
        width: "450px",

        boxShadow: "1px 1px 1px 1px rgba(0,0,0,0.1)",
        borderRadius: "10px",
        backgroundColor: "white",

        "& #info": {
            padding: "20px",
            fontSize: "25px",
            fontWeight: "bold",
        },

        "& #credit": {
            fontSize: "20px",
            padding: "10px",
            textAlign: "center",
            fontWeight: "bold",
            color: theme.palette.primary.main,
        },

        "& li": {
            fontSize: "15px",
            padding: "5px",
            color: "gray"
        },

        "@media(max-width:770px)": {
            width: "100%",
        }
    },

    participate: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap",

        "& #box": {

            width: "160px",
            margin: "10px",
            borderRadius: "10px",
            //  border: "1px solid gray",
            boxShadow: "1px 1px 1px 1px rgba(0,0,0,0.2)",
            textAlign: "center",
            fontSize: "20px",
            fontWeight: 500,
            padding: "5px",

            "&:hover": {
                cursor: "pointer",
                color: theme.palette.primary.main,
                // border: "1px solid #00bcd4",
            },

            "@media(max-width:770px)": {
                width: "40%",
                margin: "0px",
                fontSize: "15px"
            }
        },

        "& #num": {
            fontSize: "20px",
            fontWeight: "bold",
            color: theme.palette.primary.main,
            margin: "10px",
            padding: "10px",

            "@media(max-width:770px)": {
                margin: "0px",


            }


        }
    },
    category: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap",
        "& #box": {
            backgroundColor: "#C9F7F2",
            margin: "10px 10px 0px 10px",
            borderRadius: "10px",
            // border: "1px solid",
            "&:hover": {
                // border: "1px solid #00bcd4",
                color: "#00bcd4"
            },

        },
        "& #explain": {
            textAlign: "center",
            margin: "3px",
            fontSize: "15px",
            fontWeight: 500,
            // padding: "10px",
            color: "black",

        }
    }

}));

const MyPage = () => {

    const styles = useStyles();
    const history = useHistory();

    const [personal, setPersonal] = useState({ name: "", points: 0, userID: "", my_posts: [], my_generals: [], participations: [], general_participations: [] });
    const dispatch = useDispatch();

    useEffect(() => {
        personalinfo().then(res => {
            // console.log(res);
            setPersonal({ ...res });
        }).catch(err => {
            console.log(err);
        })
        return;
    }, [])

    const onClick = (path, type) => {
        console.log(path, type)

        if (type === 0 || type === 1) {
            dispatch({
                type: "post",
                payload: {
                    type: type
                }
            })
        } else {
            dispatch({
                type: "general",
                payload: {
                    type: type
                }
            })
        }

        history.push(path)

    }

    return (
        <div className={styles.container}>
            <div className={styles.box}>
                <div className={styles.charactor}>
                    <div>캐릭터</div>
                    <img src={logo} alt="charactor" />
                </div>
                <div className={styles.basic}>
                    <div>기본정보</div>
                    <ul>
                        <li>닉네임: {personal.name}</li>
                        <li>아이디: {personal.userID}</li>
                        <li>비밀번호: ************ </li>
                    </ul>

                </div>
            </div>
            <div className={styles.box}>
                <div className={styles.information}>
                    <div id="info">참여정보</div>
                    <div id="credit">{personal.points} 크레딧</div>
                    <ul>
                        <li>설문 1회 참여시 1크레딧을 얻을 수 있어요</li>
                        <li>1 크레딧으로 설문 게시글을 1회 업로드할 수 있어요<br />(게시 기간은 3일 입니다.)</li>
                    </ul>
                    <div className={styles.participate}>

                        <div id="box" onClick={(e) => onClick("mypage/mypost", 0)}>
                            업로드한 리서치
                            <div id="num">{personal.my_posts.length} 개</div>
                        </div>
                        <div id="box" onClick={(e) => onClick("mypage/mypost", 1)} >
                            참여한 리서치
                            <div id="num">{personal.participations.length} 개</div>
                        </div>
                        <div id="box" onClick={(e) => onClick("mypage/mygeneral", 2)}>
                            업로드한 투표
                            <div id="num">{personal.my_generals.length} 개</div>
                        </div>
                        <div id="box" onClick={(e) => onClick("mypage/mygeneral", 3)}>
                            참여한 투표
                            <div id="num">{personal.general_participations.length} 개</div>
                        </div>
                    </div>
                    <div className={styles.category}>
                        <div >
                            <IconButton id="box">
                                <CardGiftcardOutlinedIcon fontSize="large" />
                            </IconButton >
                            <div id="explain">경품함</div>
                        </div>
                        <div >
                            <IconButton id="box">
                                <CardGiftcardOutlinedIcon fontSize="large" />
                            </IconButton >
                            <div id="explain">경품함</div>
                        </div>  <div >
                            <IconButton id="box">
                                <CardGiftcardOutlinedIcon fontSize="large" />
                            </IconButton >
                            <div id="explain">경품함</div>
                        </div>

                    </div>
                    <div className={styles.category}>
                        <div >
                            <IconButton id="box">
                                <CardGiftcardOutlinedIcon fontSize="large" />
                            </IconButton >
                            <div id="explain">경품함</div>
                        </div>
                        <div >
                            <IconButton id="box">
                                <CardGiftcardOutlinedIcon fontSize="large" />
                            </IconButton >
                            <div id="explain">경품함</div>
                        </div>
                        <div >
                            <IconButton id="box">
                                <ReportProblemOutlinedIcon fontSize="large" />
                            </IconButton >
                            <div id="explain">경품함</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyPage;